export default {
  form: {
    app: "APP",
    userId: "User ID",
    creator: "Creator",
    utr: "UTR",
    action: "Action",
    examine: "Examine",
    state: "State",
    createTime: "Creation Time",
    processTime: "Processing Time",
    kf: "Customer Service",
    assign: "Assign",
    orderType: "Order Type",
    defaultOrder: "Default Order",
    largeOrder: "Large Order",
    problemOrder: "Problem Order",
    largeIssueOrder: "Large Problem Order",
  },
  table: {
    app: "APP",
    userId: "User ID",
    creator: "Creator",
    uploadImage: "Upload Image",
    utr: "UTR",
    amount: "Amount",
    payTime: "Payment Time",
    processTime: "Process Time",
    pdf: "PDF",
    video: "Video",
    action: "Action",
    remark: "Remark",
    orderNo: "Order Number",
    channelName: "Channel Name",
    relationType: "Order Type",
    adminUsername: "Admin Username",
    imageStatus: "Image Material Status",
    pdfStatus: "PDF Material Status",
    videoStatus: "Video Material Status",
    orderStatus: "Order Status",
    l1Remark: "L1 CS Remark",
    l2Remark: "L2 CS Remark",
    createTime: "Creation Time",
    view: "View",
    assignTime: "Assignment Time",
    operator: "Operator",
    assigner: "Assigner",
    grade: "VIP Level",
    orderType: "Order Type",
    cancelAt: "Auto Success Time",
  },
  paymentStatus: {
    pendingReview: "Pending Review",
    failed: "Payment Failed",
    success: "Payment Success",
    refunded: "Payment Refunded",
    pending: "Payment Pending",
    fakeProof: "Fake Proof",
  },
  common: {
    success: "Success",
    failed: "Failed",
    processing: "Processing",
    withdraw: "Withdraw",
    deposit: "Deposit",
    invalidPreviewLink: "Invalid preview link",
    selectItem: "Please select an item from the list",
    currentVersion: "Current Version",
    historyRecord: "History Record",
    viewPDF: "View PDF",
    openInNewWindow: "Open in New Window",
  },
  validate: {
    select: "Please select",
    input: "Please enter",
  },
  result: {
    success: "Review Successful",
  },
};
